export default class ShareButtonsController {
    constructor() {
        const shareButtons = document.querySelectorAll('.c-post-signle__share');
        
        if (shareButtons.length > 0) {
            import(
                /* webpackChunkName: "shareButtons" */ "../classes/ShareButtons"
            ).then(res => {
                const ShareButtons = res.default;
                return new ShareButtons();
            }).catch(err => {
                console.error('Failed to load ShareButtons:', err);
            });
        }
    }
}

